module.exports = __webpack_public_path__ + "img/r2pp.57180be6.png";